module.exports = __webpack_public_path__ + "img/arrow_down_square.28c54fa3.svg";